'kiwi public';

import _trimInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/trim";
export default {
  data: function data() {
    return {
      show_help: false
    };
  },
  computed: {
    aliasText: {
      get: function getAliasText() {
        var _context;
        return _trimInstanceProperty(_context = this.$state.setting('aliases')).call(_context);
      },
      set: function setAliasText(newVal) {
        this.$state.setting('aliases', _trimInstanceProperty(newVal).call(newVal));
      }
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SettingsAliases"]
window._kiwi_exports.components.SettingsAliases = (typeof exports !== 'undefined' ? (exports.default || exports) : (typeof module !== 'undefined' && module.exports ? (module.exports.default || module.exports) : {}));
